export const premiumStyles = {
	background: { default: '#f5f5f5', paper: '#ffffff' },
	primaryColor: '#bf2d25',
	header: { backgroundColor: '#000000', color: '#ffffff' },
	sidebar: { backgroundColor: '#000000', color: '#ffffff' },
	button: {
		backgroundColor: '#bf2d25',
		color: '#ffffff',
		border: '1px solid #bf2d25',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#000000',
			color: '#ffffff',
			border: '1px solid #000000',
		},
	},
	title: { color: '#000000' },
	text: { color: '#000000', buttonLoadingColor: '#ffffff' },
	tab: { backgroundColor: '#feca0b', color: '#000000' },
	table: { headerBackgroundColor: '#000000', headerTextColor: '#ffffff' },
	dataGrid: {
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		'& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader': {
			backgroundColor: '#000000',
			color: '#ffffff',
		},
		'& .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIconButton, & .MuiDataGrid-columnSeparator': {
			color: '#ffffff',
		},
		'& .MuiDataGrid-row:hover': { backgroundColor: '#fff8df' },
		'& .MuiDataGrid-cell a': { color: '#bf2d25', textDecoration: 'underline' },
	},
	dataGridToolbar: { backgroundColor: '#f5f5f5', borderBottom: '1px solid #dddddd' },
	paper: { backgroundColor: '#ffffff', border: '1px solid #dddddd' },
	platformName: { name: 'Premium Parking Platform' },
	logo: {
		small: { src: '/premium/premium-icon-white.svg', height: 37, width: 36 },
		large: { src: '/premium/premium-logo-white.svg', height: 46, width: 160 },
	},
	favicon: { src: '/premium/premium-icon-red.svg', type: 'image/svg+xml' },
	monthlyCheckoutTextColor: '#ffffff',
	socials: {},
	// Set an external destination when Premium's branded domain is confirmed.
	siteUrl: '',
	orgName: 'Premium',
};
